import {GLOBAL} from '../deprecated/global';
import {store} from '../store';
import {$qs} from '../../../@shared/ts/dom';
import {renderOrderNotice} from '../payment/order';

export function initDeliveryDate() {
	$qs('#delivery-date')?.addEventListener('change', checkDeliveryDateIsValid);

	/**
	 * Keep order delivery up to date.
	 */
	store.subscribe(() => {
		renderDeliveryDate(); // Farmtofork
	});
}

export function collectDeliveryDate(): string {
	return $qs<HTMLInputElement>('#delivery-date')?.value ?? '';
}

/**
 * Display delivery Date input for farm2fork website
 */
function renderDeliveryDate(): void {
	if (!GLOBAL.phpData) {
		return;
	}

	if (!GLOBAL.phpData.plugin_woocommerce_order_delivery_active) {
		return;
	}

	$qs('#checkout-delivery-date')?.classList.remove('hide');
	const todayDate = new Date();
	const maxDate = new Date();
	maxDate.setDate(todayDate.getDate() + (GLOBAL.phpData.plugin_woocommerce_order_delivery_options?.wc_od_max_delivery_days ?? 0));

	const $shippingDate = $qs<HTMLInputElement>('#delivery-date');

	if (!$shippingDate) {
		return;
	}

	$shippingDate.required = true;
	$shippingDate.min = todayDate.toISOString().slice(0, 10);
	$shippingDate.max = maxDate.toISOString().slice(0, 10);
}

function checkDeliveryDateIsValid(event: Event): void {
	if (!event.target) {
		return;
	}

	if (!validateDateIsAvailable((event.target as HTMLInputElement).value)) {
		(event.target as HTMLInputElement).value = '';
		renderOrderNotice('Please select another delivery date.');
	}
}

function validateDateIsAvailable(dateString: string): boolean {
	if (!GLOBAL.phpData) {
		return false;
	}

	const day = (new Date(dateString + 'T00:00:00')).getDay();
	return !(GLOBAL.phpData.plugin_woocommerce_order_delivery_options?.delivery_unchecked_day?.includes(String(day)));
}
